import * as React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import FingerLimits from "./FingerLimits"
import FingerEmployeeTabs from "./FingerEmployeeTabs"
import PropTypes from 'prop-types'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Typography from '@material-ui/core/Typography'
function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  )
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
}


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function LabTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const classes = useStyles();

  return (
    <div className="row bg-white rounded  mt-6 mb-6">
    <div className={classes.root}>
    <AppBar position="static">
      <Tabs value={value} onChange={handleChange}>
        <Tab label="İstifadəçi kartları və barmaq izi limiti" />
        <Tab label="Əməkdaş kartları və barmaq izi limiti" />
      </Tabs>
    </AppBar>
    {value === 0 && (
      <TabContainer>
        <FingerLimits />
      </TabContainer>
    )}
    {value === 1 && (
      <TabContainer>
        < FingerEmployeeTabs/>
      </TabContainer>
    )}
  </div>
   
  </div>
  );
}